import { Pipe, PipeTransform } from '@angular/core';
import { TimefenceWeekData } from '../../osp-ui/components/form/timefence/contract/timefence-week-data.contract';
import { DayOfWeek } from '../enums/day-of-week.enum';

@Pipe({
  name: 'hoursInDaySelected',
  standalone: true,
})
export class HoursInDaySelectedPipe implements PipeTransform {
  transform(formChange: TimefenceWeekData | null | undefined, day: DayOfWeek) {
    return (formChange?.[day] || []).length > 0;
  }
}
